import { emailVerification, sendVerificationCode } from "../../feathers";

const actions = {
    async sendVerificationCode(_, email) {
        return await sendVerificationCode(email);
    },

    async verifyCode(_, { email, code }) {
        return await emailVerification(code, email);
    }
};


export default {
    namespaced: true,
    actions
}